/**
 * AI Agent API - GL-BE-001
 * Endpoint: GET /ai-agent/stats
 */

import { apiGetWithFallback } from './api-response';

export interface AIAgentStats {
  totalConversations: number;
  leadsQualified: number;
  avgResponseTime: string;
  satisfactionRate: number;
  recentConversations: {
    id: string;
    visitor: string;
    message: string;
    timestamp: string;
    status: string;
  }[];
}

export async function getAIAgentStats(): Promise<AIAgentStats> {
  const data = await apiGetWithFallback<{ stats: AIAgentStats }>('/ai-agent/stats', {
    stats: {
      totalConversations: 0,
      leadsQualified: 0,
      avgResponseTime: '—',
      satisfactionRate: 0,
      recentConversations: [],
    },
  });
  return data.stats;
}
